import { useEffect } from 'react';
import { createContext, useState } from 'react';
import { resourceApi,sessionApi } from './interceptors';
import { resource_server } from "@utils/settings"

const GlobalStateContext = createContext();


const GlobalStateProvider = ({ children }) => {
    const [profile, setProfile] = useState({})
    const [hideMenu, setHideMenu] = useState(false)
    const [redirectUrl, setRedirectUrl] = useState(null);
    const [loading, setLoading] = useState({
        isLoading: true,
        message: '',
        duration: 10
    })
    const [appSettings] = useState()
    const [settings, setSettings] = useState()



    async function refreshProfile(){
        setProfile(await resourceApi.get('/v1/user'))
        
    }

    useEffect(()=>{

        async function init(){
              try{
                    await sessionApi.get('/session')
                } catch(ex){
                    
                     window.location.href = `${resource_server}/login?referrer=${window.location}`
                     return
                }

            try {
                
                
                setProfile(await resourceApi.get('/v1/user'))
                //setAppSettings(await resourceApi.get('/v1/app_settings'))
                setSettings(await resourceApi.get('/v1/settings'))
                setLoading((prev)=>{
                    
                        return {
                            ...prev, 
                            isLoading: false
                        }
                    })

            } catch(ex){
                debugger
            }
       
         
        }

        init()
        
        
       
    },[])
      const GlobalState = {
        profile, setProfile, loading, setLoading,settings,appSettings, hideMenu, setHideMenu,redirectUrl,setRedirectUrl,refreshProfile
    };
    return (
        <GlobalStateContext.Provider value={GlobalState}>
        {children}
        </GlobalStateContext.Provider>
    );
};

export { GlobalStateContext, GlobalStateProvider };
